import { Button, Stack, Typography } from '@mui/material'

import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import React from 'react'
import { ServiceType } from 'src/utils/types';

type ServiceCardProps = {
    onClick: () => void;
} & ServiceType

const ServiceCard: React.FC<ServiceCardProps> = (props) => {
    const { image, description, title, buttonName, onClick } = props;

    return (
        <Stack width="100%" gap={2} direction="column" alignItems="center">
            {image &&
                <img
                    src={image}
                    alt={title}
                    style={{ minWidth: '100%', maxWidth: '100%', height: 'auto', display: 'block', borderRadius: "8px" }}
                />}
            <Stack gap={2} direction="column">
                <Typography variant="h4_Thin">
                    {title}
                </Typography>
                <Typography lineHeight={1.7} variant="h6_Thin" color="#b3b3b3">
                    {description.content1.title.length > 200
                        ? `${description.content1.title.slice(0, 200)}...`
                        : description.content1.title}
                </Typography>
                <Button onClick={onClick} sx={{ width: "10rem" }} endIcon={<NavigateNextIcon fontSize='small' sx={{ color: "primary.main", mt: 0.5 }} />}>
                    <Typography variant="h6_Thin" color="primary.main">
                        {buttonName}
                    </Typography>
                </Button>
            </Stack>
        </Stack>
    )
}

export default ServiceCard